module.exports = __webpack_public_path__ + "static/media/about-us-card-icon--1.033ea0a2.svg";